import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { MINUS, SPACE } from '../utils/frfr-string-consts';
import { ROUNDDOWN } from '../utils/excel-functions-utils';
import { protobomp_manipulator } from '../utils/frfr-protobomp-utils';
import { terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_KAMENAVUNA, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_make_protobomp_manifest_terkk_latest } from './ter-protobomp-utils';
import { terUtilsNumberRoundUp } from './ter-utils';
import { _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';
import { _derivatModulProfil_extract_50_ili_70_by_vrstaprofila } from './ter-derivat-lib-terkk-uni-dimenzije';
import { js_utils } from '../utils/frfr-js-utils';


/*
TODO


*/


export const derDraftel_terkk_prigusivacbuke_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    // draftel_codecs_pack_terkk$_bundle_prigusivacbuke.default_pods_input_state(),
    tipkomore: virtel_k.tipkomore,
    mvisinaunutrasnjaizmedjukrilaca: virtel_m.mvisinaunutrasnjaizmedjukrilaca,
    msirinaunutrasnjaizmedjupregradnih: virtel_m.msirinaunutrasnjaizmedjupregradnih,
    vrstaprofila: virtel_m.vrstaprofila,

    // OLD
    // ksirinaoznaka: virtel_k.ksirinaoznaka,
    // kvisinaoznaka: virtel_k.kvisinaoznaka,
  };
  return pods_input_inherited;
};


// TODO cparams_combined uzeti materijale
export const _derivat_terkk_prigusivacbuke_izracunaj_materijale = (pods_input, cparams_combined) => {
  //
  const tipkomore = pods_input.tipkomore;
  //
  let _cpci = {};
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
    // By cparmas
    _cpci = cparams_combined.terkk_materijal_ident;
  }
  //
  let tipmetalalima = "pocinkovani";
  if (tipkomore === "HYGIENE:pro") {
    tipmetalalima = "prohrom";
  } else {
    tipmetalalima = "pocinkovani";
  }
  //
  // const prbkulisa_materijal_lim_pocinkovani = "LB00000D"; // LB00000D - LIM POCINKOVANI 0.80 - Kada tip komore nije HYGIENE:pro
  // const prbkulisa_materijal_lim_prohrom = "LC00000D"; // LC00000D - LIM PROHROM 0.80 - Kada tip komore jeste HYGIENE:pro
  let prbkulisa_materijal_lim = null;
  if (tipmetalalima === "pocinkovani") {
    prbkulisa_materijal_lim = _cpci.prbkulisa_materijal_lim_pocinkovani;
  }
  if (tipmetalalima === "prohrom") {
    prbkulisa_materijal_lim = _cpci.prbkulisa_materijal_lim_prohrom;
  }
  // const prbkulisa_materijal_kamenavuna = "A060000000000003"; // A060000000000003 - IZOLACIJA KAMENA VUNA PRIGUŠIVAČ SA STAKLENIM VOALOM KDL035 GVB
  const prbkulisa_materijal_kamenavuna = _cpci.prbkulisa_materijal_kamenavuna;
  // const prbnosac_materijal_lim_pocinkovani = "LB00000J"; // LB00000J - LIM POCINKOVANI 1.50 - Kada tip komore nije HYGIENE:pro
  // const prbnosac_materijal_lim_prohrom = "LC00000J"; // LC00000J - LIM PROHROM 1.50 - Kada tip komore jeste HYGIENE:pro
  let prbnosac_materijal_lim = null;
  if (tipmetalalima === "pocinkovani") {
    prbnosac_materijal_lim = _cpci.prbnosac_materijal_lim_pocinkovani;
  }
  if (tipmetalalima === "prohrom") {
    prbnosac_materijal_lim = _cpci.prbnosac_materijal_lim_prohrom;
  }
  //
  return {
    tipmetalalima,
    prbkulisa_materijal_lim,
    prbkulisa_materijal_kamenavuna,
    prbnosac_materijal_lim,
  };
};


//
export const _derivat_prigusivacbuke_izracunaj_visinakulisa = (pods_input) => {
  const prb_visinakulisa = (pods_input.mvisinaunutrasnjaizmedjukrilaca - 5);
  return prb_visinakulisa;
};


//
// TODO dodati da se vuna najpre deli kao u excelu a onda za sve ostale slucajeve da se deli po novim formulama
/*
const _deljenje_vune_prema_excel_formuli = () => {
  // Logika za kamenu vunu iz excela na osnovu dužine(G9), visine(F9) i širine(D9):
  const G9 = 1000; // duzina
  const F9 = 365; // visina
  const D9 = 200; // sirina
  const nesto = XIF(AND(G9 === 1000, F9 === 365, D9 === 100), "",
    XIF(AND(G9 === 1000, F9 === 365, D9 === 200), "",
      XIF(AND(G9 === 1000, F9 === 505, D9 === 100), "",
        XIF(AND(G9 === 1000, F9 === 505, D9 === 200), "",
          XIF(AND(G9 === 1000, F9 === 605, D9 === 100), 2I9,
            XIF(AND(G9 === 1000, F9 === 605, D9 === 200), 4I9,
              XIF(AND(G9 === 1000, F9 === 910, D9 === 100), 2I9,
                XIF(AND(G9 === 1000, F9 === 910, D9 === 200), 4I9,
                  XIF(AND(G9 === 1000, F9 === 1215, D9 === 100), 4I9,
                    XIF(AND(G9 === 1000, F9 === 1215, D9 === 200), 8I9,
                      XIF(AND(G9 === 1000, F9 === 1520, D9 === 100), 4I9,
                        XIF(AND(G9 === 1000, F9 === 1520, D9 === 200), 8I9,
                          XIF(AND(G9 === 1000, F9 === 1825, D9 === 100), 6I9,
                            XIF(AND(G9 === 1000, F9 === 1825, D9 === 200), 12I9,
                              XIF(AND(G9 === 1000, F9 === 2130, D9 === 100), 6I9,
                                XIF(AND(G9 === 1000, F9 === 2130, D9 === 200), 12I9,
                                  XIF(AND(G9 === 1000, F9 === 2435, D9 === 100), 8I9,
                                    XIF(AND(G9 === 1000, F9 === 2435, D9 === 200), 16I9,

                                      XIF(AND(G9 === 1500, F9 === 365, D9 === 100), "",
  XIF(AND(G9 === 1500, F9 === 365, D9 === 200), "",
  XIF(AND(G9 === 1500, F9 === 505, D9 === 100), "",
  XIF(AND(G9 === 1500, F9 === 505, D9 === 200), "",
  XIF(AND(G9 === 1500, F9 === 605, D9 === 100), 2I9,
  XIF(AND(G9 === 1500, F9 === 605, D9 === 200), 2I9,
  XIF(AND(G9 === 1500, F9 === 910, D9 === 100), 2I9,
  XIF(AND(G9 === 1500, F9 === 910, D9 === 200), 4I9,
  XIF(AND(G9 === 1500, F9 === 1215, D9 === 100), 4I9,
  XIF(AND(G9 === 1500, F9 === 1215, D9 === 200), 8I9,
  XIF(AND(G9 === 1500, F9 === 1520, D9 === 100), 4I9,
  XIF(AND(G9 === 1500, F9 === 1520, D9 === 200), 8I9,
  XIF(AND(G9 === 1500, F9 === 1825, D9 === 100), 6I9,
  XIF(AND(G9 === 1500, F9 === 1825, D9 === 200), 12I9,
  XIF(AND(G9 === 1500, F9 === 2130, D9 === 100), 6I9,
  XIF(AND(G9 === 1500, F9 === 2130, D9 === 200), 12I9,
  XIF(AND(G9 === 1500, F9 === 2435, D9 === 100), 8I9,
  XIF(AND(G9 === 1500, F9 === 2435, D9 === 200), 16I9,

  XIF(AND(G9 === 2000, F9 === 365, D9 === 100), "",
  XIF(AND(G9 === 2000, F9 === 365, D9 === 200), "",
  XIF(AND(G9 === 2000, F9 === 505, D9 === 100), "",
  XIF(AND(G9 === 2000, F9 === 505, D9 === 200), "",
  XIF(AND(G9 === 2000, F9 === 605, D9 === 100), 4I9,
  XIF(AND(G9 === 2000, F9 === 605, D9 === 200), 8I9,
  XIF(AND(G9 === 2000, F9 === 910, D9 === 100), 4I9,
  XIF(AND(G9 === 2000, F9 === 910, D9 === 200), 8I9,
  XIF(AND(G9 === 2000, F9 === 1215, D9 === 100), 8I9,
  XIF(AND(G9 === 2000, F9 === 1215, D9 === 200), 16I9,
  XIF(AND(G9 === 2000, F9 === 1520, D9 === 100), 8I9,
  XIF(AND(G9 === 2000, F9 === 1520, D9 === 200), 16I9,
  XIF(AND(G9 === 2000, F9 === 1825, D9 === 100), 12I9,
  XIF(AND(G9 === 2000, F9 === 1825, D9 === 200), 24I9,
  XIF(AND(G9 === 2000, F9 === 2130, D9 === 100), 12I9,
  XIF(AND(G9 === 2000, F9 === 2130, D9 === 200), 24I9,
  XIF(AND(G9 === 2000, F9 === 2435, D9 === 100), 16I9,
  XIF(AND(G9 === 2000, F9 === 2435, D9 === 200), 32I9,
  ""
))))))))))))))))))))))))))))))))))))))))))))))))))))));
};
*/
//
const _deljenje_vune_po_visini_prema_excel_formuli = (visina_ukupna) => {
  let koliko_a_redova = -1; // redova visine 600
  let koliko_b_redova = -1; // redova visine manje od 600
  let visina_b = 0;
  let duzina_vb_separatora = 0; // redova visine manje od 600
  const duzina_va_separatora = 595;
  /*
  Stavka 6 ima količine i dužine za standardne visine:
  Visina kulise - vsinavune - Dužina u profila (samo u B redovima) - Količina
  
  365mm-360-355mm-2kom
  505mm-500mm-495mm-2kom
  910mm-300mm-295mm-2kom
  1215mm visina kulisa za ovas slucaj imamo 2 A reda.
  1520mm-300mm-295mm-2kom
  1825mm visina kulisa za ovas slucaj imamo 3 A reda.
  2130mm-300-295mm-2kom
  2435mm visina kulisa za ovas slucaj imamo 4 A reda.
  
  Ukoliko radimo nestandardne komore svaka kamena vuna visine 600mm ima po jedan vertikalni profil 595mm. Svaka naredna kamena vuna (ostatak do ukupne visine kamene vune u kulisi) ima po jedan profil koji je za 5mm kraći od visine kamene vune.
  */
  // Sledeće visine kulisa smatramo standardnim: 365, 505, 910, 1520, 1825, 2130, 2430
  if (visina_ukupna === 365) { // B
    koliko_a_redova = 0;
    koliko_b_redova = 1;
    visina_b = 360;
    duzina_vb_separatora = 355;
  }
  if (visina_ukupna === 505) { // B
    koliko_a_redova = 0;
    koliko_b_redova = 1;
    visina_b = 500;
    duzina_vb_separatora = 495;
  }
  if (visina_ukupna === 910) { // AB
    koliko_a_redova = 1;
    koliko_b_redova = 1;
    visina_b = 300;
    duzina_vb_separatora = 295;
  }
  if (visina_ukupna === 1215) { // AA
    // nema B redova
    koliko_a_redova = 2;
    koliko_b_redova = 0;
    visina_b = 0;
    duzina_vb_separatora = 0;
  }
  if (visina_ukupna === 1520) { // AAB
    koliko_a_redova = 2;
    koliko_b_redova = 1;
    visina_b = 300;
    duzina_vb_separatora = 295;
  }
  if (visina_ukupna === 1825) { // AAA
    // nema B redova
    koliko_a_redova = 3;
    koliko_b_redova = 0;
    visina_b = 0;
    duzina_vb_separatora = 0;
  }
  if (visina_ukupna === 2130) { // AAAB
    koliko_a_redova = 3;
    koliko_b_redova = 1;
    visina_b = 300;
    duzina_vb_separatora = 295;
  }
  if (visina_ukupna === 2435) { // AAAA
    // nema B redova
    koliko_a_redova = 4;
    koliko_b_redova = 0;
    visina_b = 0;
    duzina_vb_separatora = 0;
  }
  //
  return {
    koliko_a_redova,
    koliko_b_redova,
    visina_b,
    duzina_vb_separatora,
  };
};
//
const _izracunaj_delove_kamene_vune_i_separatora_od_kulise = (prb_duzinakulisa,
  prb_visinakulisa, max_duzina_table, max_visina_table, minimalna_dimenzija_vune, koliko_slojeva_vune) => {
  // dodavanje kamene vune iz delova
  const duzina_ukupna = prb_duzinakulisa;
  const visina_ukupna = prb_visinakulisa;
  const visina_a = max_visina_table;
  const duzina_a = max_duzina_table;
  let visina_b = 0; // kraca od 600
  let duzina_c = 0; // kraca od 1000
  const duzina_h_separatora = (prb_duzinakulisa - 5); // duzina // NJ: Duzina: prb_duzinakulisa-5
  let duzina_va_separatora = 0;
  let duzina_vb_separatora = 0;
  // let visina_iskoriscena = 0;
  // let duzina_iskoriscena = 0;
  //
  // ----- izracun redova
  //
  let koliko_a_redova = 0; // redova visine 600
  let koliko_b_redova = 0; // redova visine manje od 600
  //
  let is_deljenje_prema_excelu = false;
  const _temp_h = _deljenje_vune_po_visini_prema_excel_formuli(visina_ukupna);
  if (js_utils.is_number_zero_or_greater(_temp_h.koliko_a_redova) || js_utils.is_number_zero_or_greater(_temp_h.koliko_b_redova)) {
    is_deljenje_prema_excelu = true;
    console.log('deljenje vune prema excelu', _temp_h);
  }
  //
  if (is_deljenje_prema_excelu) {
    // izracun redova prema excelu
    //
    koliko_a_redova = _temp_h.koliko_a_redova;
    koliko_b_redova = _temp_h.koliko_b_redova;
    visina_b = _temp_h.visina_b;
    duzina_va_separatora = 595; // NJ: svaka kamena vuna visine 600mm ima po jedan vertikalni profil dužine 595mm.
    duzina_vb_separatora = _temp_h.duzina_vb_separatora;
  } else {
    // izracun redova prema novim formulama
    //
    if (visina_ukupna === max_visina_table) {
      // imamo samo jedan A red
      koliko_a_redova = 1;
    } else if (visina_ukupna > max_visina_table) {
      // Modulo
      // Remainder (%)
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder
      const modulo = visina_ukupna % max_visina_table;
      if (modulo === 0) {
        // imamo samo A redove
        koliko_a_redova = visina_ukupna / max_visina_table;
      } else {
        // imamo i A i B visine delova u svakom redu
        koliko_a_redova = (visina_ukupna - modulo) / max_visina_table;
        koliko_b_redova = 1;
        visina_b = modulo;
      }
    } else {
      // nema A redova ni A delova
      koliko_b_redova = 1;
      visina_b = visina_ukupna;
    }
    duzina_va_separatora = visina_a;
    duzina_vb_separatora = visina_b;
  }
  //
  // izracun kolona
  //
  let koliko_a_kolona = 0; // kolona duzina 1000
  let koliko_c_kolona = 0; // redova duzine manje od 1000
  if (duzina_ukupna === max_duzina_table) {
    // imamo samo jednu A kolonu
    koliko_a_kolona = 1;
  } else if (duzina_ukupna > max_duzina_table) {
    // Modulo
    // Remainder (%)
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder
    const modulo = duzina_ukupna % max_duzina_table;
    console.log('kolone modulo', modulo);
    if (modulo === 0) {
      // imamo samo A kolone
      koliko_a_kolona = duzina_ukupna / max_duzina_table;
    } else {
      // imamo i A i C duzine delova u kolonama 
      koliko_a_kolona = (duzina_ukupna - modulo) / max_duzina_table;
      koliko_c_kolona = 1;
      duzina_c = modulo;
    }
  } else {
    // nema A kolona ni A delova
    koliko_c_kolona = 1;
    duzina_c = duzina_ukupna;
  }
  console.log('duzina_c', duzina_c);
  //
  // ----- korekcija za slucaj kada su B ili C ili D delovi uzi od minimalne dimenzije vune
  // CIlj je da se ne bi dobio jedan preuski komad pa zbog toga umesto jednog A i B dela vršimo korekciju da sedobiju dva šira B komada.
  //
  console.log('koliko_a_redova', koliko_a_redova);
  if (koliko_a_redova > 0 && koliko_b_redova > 0) {
    // debugger
    if (visina_b < minimalna_dimenzija_vune) {
      // jedan A red i jedan B red se pretvara u dva B reda jednakih visina
      // 2024-07-09 DO DALJNJEG ISKLJUCUJEM OOVO DA BI SE PODUDARILO SA AUTOCAD CRTEZIMA
      /*
      koliko_a_redova = koliko_a_redova - 1;
      koliko_b_redova = koliko_b_redova + 1;
      visina_b = (visina_a + visina_b) / 2;
      */
    }
  }
  console.log('koliko_a_redova', koliko_a_redova);
  console.log('koliko_a_kolona', koliko_a_kolona);
  if (koliko_a_kolona > 0 && koliko_c_kolona > 0) {
    if (duzina_c < minimalna_dimenzija_vune) {
      // jedna A kolona i jedna C kolona se pretvara u dve C kolone jednakih dužina
      // 2024-07-09 DO DALJNJEG ISKLJUCUJEM OOVO DA BI SE PODUDARILO SA AUTOCAD CRTEZIMA
      /*
      koliko_a_kolona = koliko_a_kolona - 1;
      koliko_c_kolona = koliko_c_kolona + 1;
      duzina_c = (duzina_a + duzina_c) / 2;
      */
    }
  }
  console.log('koliko_a_kolona', koliko_a_kolona);
  //
  // ----- finalizacija proracuna
  //
  const koliko_ukupno_redova = koliko_a_redova + koliko_b_redova;
  const koliko_ukupno_kolona = koliko_a_kolona + koliko_c_kolona;
  const koliko_h_separatora = koliko_ukupno_redova - 1;
  const koliko_va_separatora = koliko_a_redova * (koliko_ukupno_kolona - 1);
  const koliko_vb_separatora = koliko_b_redova * (koliko_ukupno_kolona - 1);
  //
  let koliko_a_delova = 0;
  let koliko_b_delova = 0;
  let koliko_c_delova = 0;
  let koliko_d_delova = 0;
  //
  console.log('koliko_a_kolona', koliko_a_kolona);
  for (let red = 1; red <= koliko_a_redova; red++) {
    // EACH red A visine
    console.log('red A visine', red);
    for (let kolona = 1; kolona <= koliko_ukupno_kolona; kolona++) {
      // EACH kolona A ili C
      if (kolona > koliko_a_kolona) {
        console.log('kolona C', kolona);
        koliko_c_delova++;
      } else {
        console.log('kolona A', kolona);
        koliko_a_delova++;
      }
    }
  }
  //
  for (let red = 1; red <= koliko_b_redova; red++) {
    // EACH red B visine
    console.log('red B visine', red);
    for (let kolona = 1; kolona <= koliko_ukupno_kolona; kolona++) {
      // EACH kolona B ili D
      if (kolona > koliko_a_kolona) {
        console.log('kolona C', kolona);
        koliko_d_delova++;
      } else {
        console.log('kolona A', kolona);
        koliko_b_delova++;
      }
    }
  }
  //
  return {
    visina_a,
    duzina_a,
    visina_b,
    duzina_c,
    koliko_a_delova: (koliko_a_delova * koliko_slojeva_vune), // * koliko_slojeva_vune
    koliko_b_delova: (koliko_b_delova * koliko_slojeva_vune),
    koliko_c_delova: (koliko_c_delova * koliko_slojeva_vune),
    koliko_d_delova: (koliko_d_delova * koliko_slojeva_vune),
    duzina_va_separatora,
    duzina_vb_separatora,
    duzina_h_separatora,
    koliko_h_separatora,
    koliko_va_separatora,
    koliko_vb_separatora,
  };
};


//
export const _derivat_terkk_prb_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {
    msirinaunutrasnjaizmedjupregradnih,
    prb_rastojanjeizmedjukulisa,
    prb_duzinakulisa,
    prb_visinakulisa,
    prb_sirinakulisa,
    prbnosac_brojkomadausetustezaca,
    prbnosac_omega_duzina,
    tervrstaprofila_50_ili_70,
  } = protobomp_superdata;
  //
  if (tervrstaprofila_50_ili_70 === "50") {
    // item.cnccrtez = "P01-09-A-35";
    _visina_20_ili_35 = 20;
    _naziv_profil_komore_50_ili_70 = "P50";
  }
  if (tervrstaprofila_50_ili_70 === "70") {
    // item.cnccrtez = "P01-09-A-35";
    _visina_20_ili_35 = 35;
    _naziv_profil_komore_50_ili_70 = "P70";
  }
  //
  //
  if (true) {
    // sklop
    if (family === 'terkk$prbkulisa/SKLOP_KULISA') { // 1.
      item.tip = "A"; // DIRTY
      item.prb_duzinakulisa = prb_duzinakulisa; // DIRTY
      item.prb_visinakulisa = prb_visinakulisa; // DIRTY
      item.prb_sirinakulisa = prb_sirinakulisa; // DIRTY
      _naziv = "KULISA PRIGUSIVACA D" + prb_duzinakulisa + "V" + prb_visinakulisa + "S" + prb_sirinakulisa + MINUS + _materijal; //
    }
    // sklop
    if (family === 'terkk$prbnosac/SKLOP_NOSAC') { // 7.
      item.tip = "A"; // DIRTY
      item.prbnosac_omega_duzina = prbnosac_omega_duzina; // DIRTY
      item.visina = _visina_20_ili_35; // DIRTY
      item.prb_sirinakulisa = prb_sirinakulisa; // DIRTY
      item.prb_rastojanjeizmedjukulisa = prb_rastojanjeizmedjukulisa; // DIRTY
      // "NOSAC KULISA PRIGUSIVACA DUZINA $msirinaunutrasnjaizmedjupregradnih-2" -K "$prb_sirinakulisa“-„ $prb_rastojanjeizmedjukulisa“-„ H35/20(u zamisnosti od profila P50-P70) „-„ $Materijal
      _naziv = "NOSAC KULISA PRIGUSIVACA DUZINA " + (msirinaunutrasnjaizmedjupregradnih - 2) + "-K" + + prb_sirinakulisa + MINUS + prb_rastojanjeizmedjukulisa + "-H" + _visina_20_ili_35 + MINUS + _materijal; //
    }
    //
    if (family === 'terkk$prbkulisa/ELEMENT_KULISE_H') { // 2. P1
      item.tip = "ELEMENT_KULISE_H"; // DIRTY
      item.cncprogram1 = "PRB-P1.S4"; // DIRTY
      /*
      terkk$prbkulisa/ELEMENT_KULISE_H
      Dužina= $prb_duzinakulisa
      Dim. 2 = $prb_sirinakulisa
      */
      item.dimenzija1 = prb_duzinakulisa; // DIRTY
      item.dimenzija2 = prb_sirinakulisa; // DIRTY
      item.razvijenamera1 = prb_duzinakulisa + 24; // DIRTY duzina
      item.razvijenamera2 = prb_sirinakulisa + 91; // DIRTY sirina
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      _naziv = "ELEMENT KULISE H-" + prb_duzinakulisa + "x" + prb_sirinakulisa + MINUS + _materijal; //
      // CNC crtez: "P01-21-A-K"$prb_sirinakulisa"-"$prb_duzinakulisa"-P1"
      _cnc = "P01-21-A-K" + prb_sirinakulisa + MINUS + prb_duzinakulisa + MINUS + "P1"; //
      if (prb_sirinakulisa > 100) {
      } else {
        // Napomena: Ukoliko je $prb_sirinakulisa=100mm, radni centar za operaciju2 je Ermaksan(ista situacija kao kod postolja)
        item.rc2 = "RCPRSER";
      }
    }
    //
    if (family === 'terkk$prbkulisa/ELEMENT_KULISE_V') { // 3. P2
      item.tip = "ELEMENT_KULISE_V"; // DIRTY
      item.cncprogram1 = "PRB-P2.S4"; // DIRTY
      /*
      terkk$prbkulisa/ELEMENT_KULISE_V
      Dužina= $prb_visinakulisa
      Dim. 2 = $prb_sirinakulisa
      */
      item.dimenzija1 = prb_visinakulisa; // DIRTY
      item.dimenzija2 = prb_sirinakulisa; // DIRTY
      item.razvijenamera1 = prb_visinakulisa + 24; // duzina
      item.razvijenamera2 = prb_sirinakulisa + 91; // sirina
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      _naziv = "ELEMENT KULISE V-" + prb_visinakulisa + "x" + prb_sirinakulisa + MINUS + _materijal; //
      // CNC crtez: "P01-21-A-K"$prb_sirinakulisa"-"$prb_ visinakulisa "-P2"
      _cnc = "P01-21-A-K" + prb_sirinakulisa + MINUS + prb_visinakulisa + MINUS + "P2"; //
      if (prb_sirinakulisa > 100) {
      } else {
        // Napomena: Ukoliko je $prb_sirinakulisa=100mm, radni centar za operaciju2 je Ermaksan(ista situacija kao kod postolja)
        item.rc2 = "RCPRSER";
      }
    }
    //
    if (family === 'terkk$prbkulisa/U_PROFIL_H') { // 4. P3
      item.tip = "U_PROFIL_H"; // DIRTY
      item.cncprogram1 = "PRB-P3P4.S4"; // DIRTY
      /*
      5. ostao sam dužan objašnjenje za dužine Vertikalnih U profila za stavke 5 i 6.
      Odnosi se na elment kulise (Primitivni lim op.)
      Naziv: "U PROFIL V-" Dužina U profila "X" $prb_sirinakulisa "-" $materijal
      Količina: ?(mora da bude paran broj)
      Duzina: Duzina U profila
      Sirina: $prb_sirinakulisa+55
      Površina: Duzina*Sirina
      
      5 .Odnosi se na elment kulise (Primitivni lim op.)
      Naziv: "U PROFIL H-" $prb_duzinakulisa-5 "X" $prb_sirinakulisa "-" $materijal
      Količina: MOD((Visina/600))2
      Razvijena dužina: $prb_ Dužinakulisa-5
      Razvijena širina: $prb_sirinakulisa+57
      Razvijena površina: Razvijena dužinaRazvijena širina
      
      terkk$prbkulisa/U_PROFIL_H
      Dužina= $prb_ Dužinakulisa-5
      Dim. 2 = $prb_sirinakulisa
      */
      // const duzina_h_separatora = (prb_duzinakulisa - 5); // duzina // NJ: Duzina: prb_duzinakulisa-5
      // razvijenamera1: duzina_h_separatora, // Razvijena dužina: $prb_ Dužinakulisa-5 // TODO Duzina U profila???
      // item.razvijenamera1= prb_duzinakulisa - 5; // DIRTY // Razvijena dužina: $prb_ Dužinakulisa-5
      item.razvijenamera2 = prb_sirinakulisa + 57; // DIRTY // Razvijena širina: $prb_sirinakulisa+57
      // item.dimenzija1 = prb_duzinakulisa - 5; // DIRTY
      item.dimenzija1 = item.razvijenamera1; // DIRTY
      item.dimenzija2 = prb_sirinakulisa; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      const _duzina_u_profila = item.dimenzija1; // duzina // Duzina U profila
      _naziv = "U PROFIL H-" + _duzina_u_profila + "X" + prb_sirinakulisa + MINUS + _materijal; //
      // CNC crtez: "P01-21-A-K"$prb_sirinakulisaMINUS$prb_ duzinakulisa "-P3"
      // _cnc = "P01-21-A-K" + MINUS + prb_sirinakulisa + MINUS + prb_duzinakulisa + MINUS + "P3"; //
      // NOVO "P01-21-A-K"$prb_sirinakulisa"-" $Duzina U profila"-P3"
      _cnc = "P01-21-A-K" + prb_sirinakulisa + MINUS + _duzina_u_profila + "-P3"; //
      if (prb_sirinakulisa > 100) {
      } else {
        // Napomena: Ukoliko je $prb_sirinakulisa=100mm, radni centar za operaciju2 je Ermaksan(ista situacija kao kod postolja)
        item.rc2 = "RCPRSER";
      }
    }
    //
    if (family === 'terkk$prbkulisa/U_PROFIL_VA' || family === 'terkk$prbkulisa/U_PROFIL_VB') { // 5. i 6. P4
      if (family === 'terkk$prbkulisa/U_PROFIL_VA') { // 5. P4
        item.tip = "U_PROFIL_VA"; // DIRTY
        /*
        ostao sam dužan objašnjenje za dužine Vertikalnih U profila za stavke 5 i 6.
        Duzina: Duzina U profila
        Sirina: $prb_sirinakulisa+55
        Površina: Duzina*Sirina
        
        Razvijena dužina: Duzina U profila
        Razvijena širina: $prb_sirinakulisa+55
        Razvijena površina: Razvijena dužina*Razvijena širina
        
        terkk$prbkulisa/U_PROFIL_VA
        Dužina= imamo po logici iz posta od 27 jula u okviru ove grupe ( 10 posta iznad-počinje sa Žarko,
        ostao sam dužan objašnjenje za dužine Vertikalnih U profila za stavke 5 i 6...)
        Dim. 2 = $prb_sirinakulisa
        */
        // razvijenamera1: duzina_va_separatora, // duzina // Duzina U profila
        item.razvijenamera2 = prb_sirinakulisa + 55; // DIRTY // Razvijena širina: $prb_sirinakulisa+55
        item.dimenzija1 = item.razvijenamera1; // DIRTY
        item.dimenzija2 = prb_sirinakulisa; // DIRTY
      }
      if (family === 'terkk$prbkulisa/U_PROFIL_VB') { // 6. P4
        item.tip = "U_PROFIL_VB"; // DIRTY


        /*
        ostao sam dužan objašnjenje za dužine Vertikalnih U profila za stavke 5 i 6.
        Duzina: Duzina U profila
        Sirina: $prb_sirinakulisa+55
        Površina: Duzina*Sirina
        
        Razvijena dužina: Duzina U profila
        Razvijena širina: $prb_sirinakulisa+55
        Razvijena površina: Razvijena dužina*Razvijena širina
        
        terkk$prbkulisa/U_PROFIL_VB
        Dužina= imamo po logici iz posta od 27 jula u okviru ove grupe ( 10 posta iznad-počinje sa Žarko,
        ostao sam dužan objašnjenje za dužine Vertikalnih U profila za stavke 5 i 6...)
        Dim. 2 = $prb_sirinakulisa
        */
        // razvijenamera1: duzina_vb_separatora, // duzina // Duzina U profila
        item.razvijenamera2 = prb_sirinakulisa + 55; // DIRTY // Razvijena širina: $prb_sirinakulisa+55
        item.dimenzija1 = item.razvijenamera1; // DIRTY
        item.dimenzija2 = prb_sirinakulisa; // DIRTY
      }
      item.cncprogram1 = "PRB-P3P4.S4"; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      const _duzina_u_profila = item.dimenzija1; // duzina // Duzina U profila
      _naziv = "U PROFIL V-" + _duzina_u_profila + "X" + prb_sirinakulisa + MINUS + _materijal; //
      // CNC crtez: "P01-21-A-K" $Duzina U profila "-"$prb_ duzinakulisa "-P4"
      // _cnc = "P01-21-A-K" + MINUS + _duzina_u_profila + MINUS + prb_duzinakulisa + MINUS + "P4"; //
      // NOVO "P01-21-A-K"$prb_sirinakulisa"-" $Duzina U profila"-P4"
      _cnc = "P01-21-A-K" + prb_sirinakulisa + MINUS + _duzina_u_profila + "-P4"; //
      if (prb_sirinakulisa > 100) {
      } else {
        // Napomena: Ukoliko je $prb_sirinakulisa=100mm, radni centar za operaciju2 je Ermaksan(ista situacija kao kod postolja)
        item.rc2 = "RCPRSER";
      }
    }
    //
    if (family === 'terkk$prbnosac/LIM_OMEGA' || family === 'terkk$prbnosac/LIM_OMEGA_1_2' || family === 'terkk$prbnosac/LIM_OMEGA_2_2') { // 8. P6
      item.tip = "OMEGA_PROFIL"; // DIRTY
      item.prb_sirinakulisa = prb_sirinakulisa; // DIRTY
      /*
      OMEGA NOSAC KULISA
      Razvijena dužina: $msirinaunutrasnjaizmedjupregradnih-2
      Razvijena širina: H35-134mm/ H20-104mm
      Razvijena površina: Razvijena dužina*Razvijena širina
      
      terkk$prbnosac/LIM_OMEGA
      Dužina= $msirinaunutrasnjaizmedjupregradnih - 2
      Dim. 2 = 35 ili 20 zavisno od $vrstaprofila da li je P70 ili P50
      */
      // let prbnosac_omega_duzina = (msirinaunutrasnjaizmedjupregradnih - 2); // Razvijena dužina: $msirinaunutrasnjaizmedjupregradnih-2
      // item.dimenzija1 = (msirinaunutrasnjaizmedjupregradnih - 2); // DIRTY
      // razvijenamera1: prbnosac_omega_duzina, // Razvijena dužina
      item.dimenzija1 = item.razvijenamera1; // DIRTY
      // razvijenamera2: prbnosac_omega_visina,
      item.dimenzija2 = item.razvijenamera2; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      // Naziv: "OMEGA NOSAC KULISA " $msirinaunutrasnjaizmedjupregradnih-2"-K" $prb_sirinakulisa "-" $prb_rastojanjeizmedjukulisa“-„ H35/20(u zamisnosti od profila P50-P70) „-„ $Materijal
      // TODO ovo za -2
      _naziv = "OMEGA NOSAC KULISA " + (msirinaunutrasnjaizmedjupregradnih - 2) + "x" + prb_sirinakulisa + MINUS + prb_rastojanjeizmedjukulisa + MINUS + "H" + _visina_20_ili_35 + MINUS + _materijal; //
      // CNC crtez: "P01-21-A-K"$prb_sirinakulisa"-"$prb_rastojanjeizmedjukulisa “-„ H35/20(u zamisnosti od profila P50-P70) „-„ $Materijal „-P6"
      _cnc = "P01-21-A-K" + prb_sirinakulisa + MINUS + prb_rastojanjeizmedjukulisa + MINUS + item.dimenzija1 + "-H" + _visina_20_ili_35 + MINUS + _materijal + "-P6"; //
      // Napomena: Kada je širina komore >2500mm element se proizvodi iz dva dela -P6.1 i -P6.2
      item.prb_rastojanjeizmedjukulisa = prb_rastojanjeizmedjukulisa; // DIRTY
      if (family === 'terkk$prbnosac/LIM_OMEGA_1_2') {
        _naziv += SPACE + "2od2";
        _cnc += '.1'; // SUFIX
        item.ter_koji_deo_visedelnog = 1; // DIRTY
      }
      if (family === 'terkk$prbnosac/LIM_OMEGA_2_2') {
        _naziv += SPACE + "2od2";
        _cnc += '.2'; // SUFIX
        item.ter_koji_deo_visedelnog = 2; // DIRTY
      }
    }
    //
    if (family === 'terkk$prbnosac/SET_STEZACA') { // 9. P5
      item.tip = "STEZAC_PRIGUSIVACA"; // DIRTY
      /*
      terkk$prbnosac/SET_STEZACA
      Dužina= $prb_sirinakulisa
      Dim. 2 = uvek je 48mm
      */
      item.dimenzija1 = prb_sirinakulisa; // DIRTY
      item.dimenzija2 = 48; // DIRTY
      item.razvijenamera1 = 250; // Razvijena dužina: 250MM
      // TODO Razvijena širina: K200-269mm/ K100-169mm
      // slucaj K200 je kad je prb_silirnakulisa 200 i K100 kad je porb_sirinakulisa=100, posto moez da bude samo 100 ili 200.
      if (prb_sirinakulisa === 100) {
        item.razvijenamera2 = 169; // Razvijena širina: K100-169mm
      } else if (prb_sirinakulisa === 200) {
        item.razvijenamera2 = 269; // Razvijena širina: K200-269mm
      }
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      item.prbnosac_brojkomadausetustezaca = prbnosac_brojkomadausetustezaca; // DIRTY
      // Naziv: "SET PRITEZACA KULISE K" $prb_sirinakulisa „-„ $Materijal
      _naziv = "SET PRITEZACA KULISE K" + prb_sirinakulisa + MINUS + _materijal;
      // CNC crtez: "P01-21-A-K"$prb_sirinakulisa"-4K-P5"
      _cnc = "P01-21-A-K" + prb_sirinakulisa + "-4K-P5"; //
    }
    //
    if (family === 'terkk$prbkulisa/VUNA_A') {
      item.tip = "KAMENA_VUNA_SA_VOALOM_A"; // DIRTY
    }
    if (family === 'terkk$prbkulisa/VUNA_B') {
      item.tip = "KAMENA_VUNA_SA_VOALOM_B"; // DIRTY
    }
    if (family === 'terkk$prbkulisa/VUNA_C') {
      item.tip = "KAMENA_VUNA_SA_VOALOM_C"; // DIRTY
    }
    if (family === 'terkk$prbkulisa/VUNA_D') {
      item.tip = "KAMENA_VUNA_SA_VOALOM_D"; // DIRTY
    }
    if (family === 'terkk$prbkulisa/VUNA_A' || family === 'terkk$prbkulisa/VUNA_B' || family === 'terkk$prbkulisa/VUNA_C' || family === 'terkk$prbkulisa/VUNA_D') {
      povrsina = item.duzina * item.visina;
    }
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_prigusivacbuke_izracunaj_za_step_protobomp = (state, pods_input) => {
  //
  const {
    msirinaunutrasnjaizmedjupregradnih,
    vrstaprofila,
  } = pods_input;
  const {
    prbkulisa_materijal_lim,
    prbkulisa_materijal_kamenavuna,
    prbnosac_materijal_lim,
    prb_sirinakulisa,
    prb_rastojanjeizmedjukulisa,
    prb_kolicinaprigusivaca,
    prb_duzinakulisa,
    prb_visinakulisa,
    // prb_kolikokulisauprigusivacu,
  } = state;
  //
  const prbnosac_brojkomadausetustezaca = 4; // broj komada u setu stezaca
  let prb_kolikokulisauprigusivacu = 0;
  let prbkulisa_kolicina = 0;
  let prbnosac_kolicina = 0;
  //
  const max_duzina_table = 1000;
  const max_visina_table = 600;
  const minimalna_dimenzija_vune = 100;
  const debljina_table_vune = 50;
  let koliko_slojeva_vune = prb_sirinakulisa / debljina_table_vune;
  //
  prb_kolikokulisauprigusivacu = ROUNDDOWN(msirinaunutrasnjaizmedjupregradnih / (prb_sirinakulisa + prb_rastojanjeizmedjukulisa), 0); // TODO treba da se dobije interger
  prbkulisa_kolicina = (prb_kolicinaprigusivaca * prb_kolikokulisauprigusivacu);
  //
  prbnosac_kolicina = (prb_kolicinaprigusivaca * 4);
  const prbnosac_deo_omega_kolicina_direktna = prbnosac_kolicina; // NJ: Izbacujemo sklop nosac i njegovi delovi sada idu direktno u protobomp. (parent je null)
  //

  let _visina_20_ili_35 = -1;
  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);
  // NJ: Visina omega profila je uvek 20mm ili 35mm zavisno od toga koji profil modula se koristi.
  if (tervrstaprofila_50_ili_70 === '50') {
    _visina_20_ili_35 = 20;
  }
  if (tervrstaprofila_50_ili_70 === '70') {
    _visina_20_ili_35 = 35;
  }

  let prbnosac_omega_duzina = (msirinaunutrasnjaizmedjupregradnih - 2); // Razvijena dužina: $msirinaunutrasnjaizmedjupregradnih-2
  let prbnosac_omega_visina = -1;
  if (_visina_20_ili_35 === 20) {
    prbnosac_omega_visina = 104; // Razvijena širina: H20-104mm
  } else if (_visina_20_ili_35 === 35) {
    prbnosac_omega_visina = 134; // Razvijena širina: H35-134mm
  }

  // TODO
  const protobomp_superdata = {
    tervrstaprofila_50_ili_70,
    msirinaunutrasnjaizmedjupregradnih,
    prb_rastojanjeizmedjukulisa,
    prb_duzinakulisa,
    prb_visinakulisa,
    prb_sirinakulisa,
    prbnosac_brojkomadausetustezaca,
    prbnosac_omega_duzina,
  };

  //
  // _subform_arr
  // let _arr = [];
  // let _subform_arr_subpp_prbkulisa = [];
  // let _subform_arr_subpp_prbnosac = [];
  // let _protobomp_subpp_prbkulisa = protobomp_manipulator.init();
  let _protobomp_subpp_prbkulisa = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$prigusivacbuke", { allow_root_btns: false }), protobomp_superdata);
  // let _protobomp_subpp_prbnosac = protobomp_manipulator.init();
  let _protobomp = _protobomp_subpp_prbkulisa;
  // let protobomp_2 = _protobomp_subpp_prbnosac;
  let _protobomp_2 = _protobomp; // ipak cemo sve u jedan protomobp // SAME REFERENCE
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_prb_pbnode_dirty_enrich;
  // ----- kreiranje sklopova
  //
  const _sklop_uzor = {
  };
  let _temp_sklop;
  let _temp_pbnode;
  // 1.
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$prbkulisa/SKLOP_KULISA',
    naziv: '* KULISA PRIGUSIVACA D1500V1520S200-SS',
    kolicina: prbkulisa_kolicina,
    identmaterijala: prbkulisa_materijal_lim, // radi oznake SS il iGS u nazivu
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_PRBKULISA');
  const { created_tempkey: sklop_prbkulisa } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  // 7.
  _temp_sklop = {
    pbnode_family: 'terkk$prbnosac/SKLOP_NOSAC',
    naziv: '* NOSAC KULISA PRIGUSIVACA 2133-K200-100-H35-SS',
    kolicina: (1 * prbnosac_kolicina),
    identmaterijala: prbnosac_materijal_lim, // radi oznake SS il iGS u nazivu
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_PRBNOSAC');
  // const { created_tempkey: sklop_prbnosackulisa } = protobomp_manipulator.add(_protobomp_2, _temp_pbnode, null); // NJ: Izbacujemo sklop nosac i njegovi delovi sada idu direktno u protobomp. (parent je null)
  //
  //
  // ----- dodavanje primitivnih u sklopove
  //
  if (true) {
    // 2. P1
    if (true) {
      const item = {
        tempkey: 111,
        tip: 'ELEMENT_KULISE_H',
        pbnode_family: 'terkk$prbkulisa/ELEMENT_KULISE_H',
        naziv: "? ELEMENT_KULISE_H",
        kolicina: 2, // po komadu sledece operacije
        identmaterijala: prbkulisa_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBS4",
        operacija2: "OPSAV",
        rc2: "RCSAVP4",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_prbkulisa);
    }
    // 3. P2
    if (true) {
      const item = {
        tempkey: 112,
        tip: 'ELEMENT_KULISE_V',
        pbnode_family: 'terkk$prbkulisa/ELEMENT_KULISE_V',
        naziv: "? ELEMENT_KULISE_V",
        kolicina: 2, // po komadu sledece operacije
        identmaterijala: prbkulisa_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBS4",
        operacija2: "OPSAV",
        rc2: "RCSAVP4",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_prbkulisa);
    }
    //
    // dodavanje delova kamene vune
    const {
      visina_a,
      duzina_a,
      visina_b,
      duzina_c,
      koliko_a_delova,
      koliko_b_delova,
      koliko_c_delova,
      koliko_d_delova,
      duzina_va_separatora,
      duzina_vb_separatora,
      duzina_h_separatora,
      koliko_h_separatora,
      koliko_va_separatora,
      koliko_vb_separatora,
    } = _izracunaj_delove_kamene_vune_i_separatora_od_kulise(prb_duzinakulisa,
      prb_visinakulisa, max_duzina_table, max_visina_table, minimalna_dimenzija_vune, koliko_slojeva_vune);
    console.log('visina_a, duzina_a, visina_b, duzina_c,',
      'koliko_a_delova, koliko_b_delova, koliko_c_delova, koliko_d_delova, ');
    console.log(visina_a,
      duzina_a,
      visina_b,
      duzina_c,
      koliko_a_delova,
      koliko_b_delova,
      koliko_c_delova,
      koliko_d_delova);
    //
    if (koliko_h_separatora > 0) {
      // 4. P3
      const item = {
        tempkey: 211,
        tip: 'U_PROFIL_H',
        pbnode_family: 'terkk$prbkulisa/U_PROFIL_H',
        naziv: "U_PROFIL_H",
        kolicina: (koliko_h_separatora * 2), // svaki separator se sastoji od 2 identicna U profila
        razvijenamera1: duzina_h_separatora, // Razvijena dužina: $prb_ Dužinakulisa-5 // TODO Duzina U profila???
        identmaterijala: prbkulisa_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBS4",
        operacija2: "OPSAV",
        rc2: "RCSAVP4",
      };
      if (prb_sirinakulisa < 101) {
        // Napomena: Ukoliko je $prb_sirinakulisa=100mm, radni centar za operaciju2 je Ermaksan(ista situacija kao kod postolja)
        item.rc2 = "RCPRSER";
      }
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_prbkulisa);
    }
    if (koliko_va_separatora > 0) {
      // 5. P4
      const item = {
        tempkey: 222,
        tip: 'U_PROFIL_VA',
        pbnode_family: 'terkk$prbkulisa/U_PROFIL_VA', // va_separator
        naziv: "U_PROFIL_VA U PROFIL V-",
        kolicina: (koliko_va_separatora * 2), // svaki separator se sastoji od 2 identicna U profila. // NJ: mora da bude paran broj
        identmaterijala: prbkulisa_materijal_lim,
        razvijenamera1: duzina_va_separatora, // duzina // Duzina U profila
        operacija1: "OPSEC",
        rc1: "RCPRBS4",
        operacija2: "OPSAV",
        rc2: "RCSAVP4",
      };
      if (prb_sirinakulisa < 101) {
        // Napomena: Ukoliko je $prb_sirinakulisa=100mm, radni centar za operaciju2 je Ermaksan(ista situacija kao kod postolja)
        item.rc2 = "RCPRSER";
      }
      item.povrsina = item.razvijenamera1 * item.razvijenamera2;
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_prbkulisa);
    }
    if (koliko_vb_separatora > 0) {
      // 6. P4
      const item = {
        tempkey: 223,
        tip: 'U_PROFIL_VB',
        pbnode_family: 'terkk$prbkulisa/U_PROFIL_VB', // vb_separator
        naziv: "U_PROFIL_VB",
        kolicina: (koliko_vb_separatora * 2), // svaki separator se sastoji od 2 identicna U profila
        identmaterijala: prbkulisa_materijal_lim,
        razvijenamera1: duzina_vb_separatora, // duzina // Duzina U profila
        operacija1: "OPSEC",
        rc1: "RCPRBS4",
        operacija2: "OPSAV",
        rc2: "RCSAVP4",
      };
      if (prb_sirinakulisa < 101) {
        // Napomena: Ukoliko je $prb_sirinakulisa=100mm, radni centar za operaciju2 je Ermaksan(ista situacija kao kod postolja)
        item.rc2 = "RCPRSER";
      }
      item.povrsina = item.razvijenamera1 * item.razvijenamera2;
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_prbkulisa);
    }
    //
    if (koliko_a_delova > 0) {
      const item = {
        tempkey: 311,
        tip: 'KAMENA_VUNA_SA_VOALOM_A',
        pbnode_family: 'terkk$prbkulisa/VUNA_A',
        naziv: "KAMENA_VUNA_SA_VOALOM_A",
        kolicina: koliko_a_delova,
        identmaterijala: prbkulisa_materijal_kamenavuna,
        visina: visina_a,
        duzina: duzina_a,
        debljina: debljina_table_vune,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_KAMENAVUNA(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_prbkulisa);
    }
    if (koliko_b_delova > 0) {
      const item = {
        tempkey: 312,
        tip: 'KAMENA_VUNA_SA_VOALOM_B',
        pbnode_family: 'terkk$prbkulisa/VUNA_B',
        naziv: "KAMENA_VUNA_SA_VOALOM_B",
        kolicina: koliko_b_delova,
        identmaterijala: prbkulisa_materijal_kamenavuna,
        visina: visina_b,
        duzina: duzina_a,
        debljina: debljina_table_vune,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_KAMENAVUNA(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_prbkulisa);
    }
    if (koliko_c_delova > 0) {
      const item = {
        tempkey: 313,
        tip: 'KAMENA_VUNA_SA_VOALOM_C',
        pbnode_family: 'terkk$prbkulisa/VUNA_C',
        naziv: "KAMENA_VUNA_SA_VOALOM_C",
        kolicina: koliko_c_delova,
        identmaterijala: prbkulisa_materijal_kamenavuna,
        visina: visina_a,
        duzina: duzina_c,
        debljina: debljina_table_vune,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_KAMENAVUNA(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_prbkulisa);
    }
    if (koliko_d_delova > 0) {
      const item = {
        tempkey: 314,
        tip: 'KAMENA_VUNA_SA_VOALOM_D',
        pbnode_family: 'terkk$prbkulisa/VUNA_D',
        naziv: "KAMENA_VUNA_SA_VOALOM_D",
        kolicina: koliko_d_delova,
        identmaterijala: prbkulisa_materijal_kamenavuna,
        visina: visina_b,
        duzina: duzina_c,
        debljina: debljina_table_vune,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_KAMENAVUNA(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_prbkulisa);
    }
    //
  }
  //
  // ----- ZATIM NOSAC...
  //
  if (true) {
    // 8. P6
    if (true) {
      // terkk$prbnosac/LIM_OMEGA_2_2
      let item_jednodelni;
      const item = {
        tempkey: 511,
        tip: 'OMEGA_PROFIL',
        pbnode_family: 'terkk$prbnosac/LIM_OMEGA',
        naziv: "? OMEGA NOSAC KULISA ",
        // kolicina: 4, // po komadu sledece operacije
        kolicina: 1, // NJ: kod nosaca kulisa prigusivaca, omega ide 1 po sklopu, a ko je dvodelni onda je duplo kraci ali kolicina 2 (ZT: Tačnije akda je dvodleni sa različitime delovima, količina osta je ista za svaki od dva različita dela).
        kolicina: prbnosac_deo_omega_kolicina_direktna, // NOVO
        identmaterijala: prbnosac_materijal_lim,
        razvijenamera1: prbnosac_omega_duzina, // Razvijena dužina
        // dimenzija2: prb_sirinakulisa + 91, // Razvijena sirina // H35-134mm/ H20-104mm
        // J35 znaci da imamo slucaj profila 70 u modulu, a H20 kad je profil 50. Znaci ako h35 onda 134mm razvijena mera, a a ako je H20 onda je 104mm.
        razvijenamera2: prbnosac_omega_visina,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      item_jednodelni = item;
      // PREPOLOVLJAVANJE MEHANIZAM sa deljenjem na pola na razlicite .1 i .2 delove
      if (item.razvijenamera1 > 2440) {
        const _prepolovljena_duzina = ROUNDDOWN(item.razvijenamera1 / 2); // NJ 2024-04-09: Kada delimo elemente na pola, kao što je pomenuto u prethodnoj stavci, potrebno je novu dimenziju zaokružiti na broj manje
        if (true) { // PREPOLOVLJAVANJE MEHANIZAM CASE dvodelno
          const item = {
            ...item_jednodelni,
            pbnode_family: 'terkk$prbnosac/LIM_OMEGA_1_2',
            razvijenamera1: _prepolovljena_duzina,
            kolicina: item_jednodelni.kolicina, // kolicina ostaje ista samo sto se pravi iz dva razlicita dela
          }
          // item.povrsina = terUtils_izracunaj_povrsinu_materijala_lim(item.visina, item.duzina);
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          // item.naziv_materijala = terUtils_get_naziv_materijala_by_ident(item.identmaterijala);
          // _subform_arr_subpp_prbkulisa.push(item);
          // _subform_arr_subpp_prbnosac.push(item);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          // protobomp_manipulator.add(_protobomp, pbnode, sklop_prbnosackulisa);
          protobomp_manipulator.add(_protobomp, pbnode, null); // NJ: Izbacujemo sklop nosac i njegovi delovi sada idu direktno u protobomp. (parent je null)
        }
        if (true) {
          const item = {
            ...item_jednodelni,
            pbnode_family: 'terkk$prbnosac/LIM_OMEGA_2_2',
            razvijenamera1: _prepolovljena_duzina,
            kolicina: item_jednodelni.kolicina, // kolicina ostaje ista samo sto se pravi iz dva razlicita dela
          };
          // item.povrsina = terUtils_izracunaj_povrsinu_materijala_lim(item.visina, item.duzina);
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          // item.naziv_materijala = terUtils_get_naziv_materijala_by_ident(item.identmaterijala);
          // _subform_arr_subpp_prbkulisa.push(item);
          // _subform_arr_subpp_prbnosac.push(item);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          // protobomp_manipulator.add(_protobomp, pbnode, sklop_prbnosackulisa);
          protobomp_manipulator.add(_protobomp, pbnode, null); // NJ: Izbacujemo sklop nosac i njegovi delovi sada idu direktno u protobomp. (parent je null)
        }
      } else { // PREPOLOVLJAVANJE MEHANIZAM CASE jednodelno
        const item = item_jednodelni;
        // item.povrsina = terUtils_izracunaj_povrsinu_materijala_lim(item.visina, item.duzina);
        _pbnode_dirty_enrich(item, protobomp_superdata, true);
        // item.naziv_materijala = terUtils_get_naziv_materijala_by_ident(item.identmaterijala);
        // _subform_arr_subpp_prbkulisa.push(item);
        // _subform_arr_subpp_prbnosac.push(item);
        const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
        // protobomp_manipulator.add(_protobomp, pbnode, sklop_prbnosackulisa);
        protobomp_manipulator.add(_protobomp, pbnode, null); // NJ: Izbacujemo sklop nosac i njegovi delovi sada idu direktno u protobomp. (parent je null)
      }
    }
    // 9. P5
    if (true) {
      const item = {
        tempkey: 512,
        tip: 'STEZAC_PRIGUSIVACA',
        pbnode_family: 'terkk$prbnosac/SET_STEZACA',
        // naziv: "STEZAC_PRIGUSIVACA ?",
        naziv: "? SET PRITEZACA KULISE K ?",
        // kolicina: prb_kolikokulisauprigusivacu, // po komadu sledece operacije
        // kolicina: 1, // po komadu sledece operacije
        kolicina: prbkulisa_kolicina, // NJ: koliko ima kulisa toliko ima stezaca na svakom nosacu
        identmaterijala: prbnosac_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      // item.povrsina = terUtils_izracunaj_povrsinu_materijala_lim(item.visina, item.duzina);
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      // item.naziv_materijala = terUtils_get_naziv_materijala_by_ident(item.identmaterijala);
      // _subform_arr_subpp_prbkulisa.push(item);
      // _subform_arr_subpp_prbnosac.push(item);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_prbnosackulisa);
      protobomp_manipulator.add(_protobomp, pbnode, null); // NJ: Izbacujemo sklop nosac i njegovi delovi sada idu direktno u protobomp. (parent je null)
    }
  }

  //
  //
  return {
    svasta: {
      prb_kolikokulisauprigusivacu,
      prbkulisa_kolicina,
      prbnosac_kolicina,
    },
    // _arr,
    // _subform_arr_subpp_prbkulisa,
    // _subform_arr_subpp_prbnosac,
    // _protobomp_subpp_prbkulisa: _protobomp,
    // _protobomp_subpp_prbnosac: _protobomp_2,
    _protobomp: _protobomp, // ipak cemo sve u jedan protobomp
  }; // TODO
};


// ---------- VIRBOM DERIVATS ----------
// NE KORISTI SE jer je ovaj draftel prebacen na protobomp koncept

